// =============================================================================
// Related Products carousel — auto-width slides hosting product-card-thumb.
// All form / pricing JS keeps working inside the carousel without wiring.
// =============================================================================
(function ($) {
    'use strict';

    $(function () {
        if (typeof Swiper === 'undefined') { return; }

        const $container = $('[data-related-products-swiper]');
        if (!$container.length) { return; }

        new Swiper($container[0], {
            slidesPerView: 'auto',
            spaceBetween: 20,
            watchOverflow: true,
            speed: 400,
            navigation: {
                prevEl: '.related-products__nav--prev',
                nextEl: '.related-products__nav--next',
            },
            a11y: {
                prevSlideMessage: 'Previous related products',
                nextSlideMessage: 'Next related products',
            },
            breakpoints: {
                0:    { slidesPerView: 1.2, spaceBetween: 14 },
                576:  { slidesPerView: 2.2, spaceBetween: 16 },
                768:  { slidesPerView: 3,   spaceBetween: 18 },
                1280: { slidesPerView: 4,   spaceBetween: 20 },
                1600: { slidesPerView: 5,   spaceBetween: 20 },
            },
        });
    });
})(jQuery);
